import { IHubService } from "../../domain/IHubService";




export const GetPrinterSectorUseCase = async (service: IHubService, sectorId: string) => {
    const response = await service.getPrinterSector(sectorId);
    return response;
};
